import React, { Component } from "react";
import moment from "moment";
import { Row, Col, Card, CardBody, FormGroup, Button, Label, Container, Spinner, Modal, ModalBody, ModalHeader, TabContent, TabPane, Nav, NavItem, NavLink, Table } from "reactstrap";
import {
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import classnames from "classnames";
// Form Editor
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"
import logo from "../../assets/images/Planmans.png"
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import draftToHtml from 'draftjs-to-html';
import Select from "react-select";

class InvoicePage extends Component {
  constructor(props) {
    super(props);
    if (this.props.obj) {
      if (!validateToken(this.props.obj.access)) {
        this.props.history.push('/logout')
      }
    }
    this.state = {
      loading: false,
      invoice: [],
      selectedTransactions: [],
      TransactionGroup: [],
      bank: {},
      obj: this.props.obj,
      activeTabJustify: "5",
      editorState: EditorState.createEmpty(),
      rawMessage: '',
    };

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
    }

    this.onEditorStateChange = this.onEditorStateChange.bind(this)
    this.tog_share = this.tog_share.bind(this)
    this.tog_edit_detail = this.tog_edit_detail.bind(this)
    this.toggleCustomJustified = this.toggleCustomJustified.bind(this)
    this.handleDetailSubmit = this.handleDetailSubmit.bind(this)
    this.Print = this.Print.bind(this)
    this.HandleValidateUserSubmit = this.HandleValidateUserSubmit.bind(this)
    this.handleSendInvoiceSubmit = this.handleSendInvoiceSubmit.bind(this)
  }

  tog_edit_detail() {
    this.setState(prevState => ({
      model_edit_detail: !prevState.model_edit_detail
    }));
    this.removeBodyCss();
  }

  tog_share() {
    this.setState(prevState => ({
      modal_share: !prevState.modal_share
    }));
    this.removeBodyCss();
  }

  toggleCustomJustified(tab) {
    if (this.state.activeTabJustify !== tab) {
      this.setState({
        activeTabJustify: tab
      });
    }
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
      rawMessage: draftToHtml(convertToRaw(editorState.getCurrentContent()))
    });
  };

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  // componentDidCatch(error) {
  //   // Changing the state to true
  //   // if some error occurs
  //   console.log(error)
  //   toastr.error("Something Went Wrong", "")

  //   this.props.obj?this.props.history.goBack():this.props.history.push('/404')
  // }

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.setState({
        isMobile: window.innerWidth < 600
      });
    }, false);
    this.loadData()
    this.loadBankDetaildata()
  }

  async loadData() {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/invoices/invoices/${this.props.id}/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          res.json()
            .then(
              (data) => {
                if (this.props.obj) {
                  toastr.error(data.detail, "")
                  this.props.history.goBack()
                } else {
                  this.props.history.push('/404')
                }
              }
            )
        }
        else {
          res.json()
            .then(
              (data) => {
                this.setState({ invoice: data, transactionDate: data.transactions[(data.transactions.length) - 1].date })
                if (this.state.obj){
                  this.loadItineraryCreditTrans(data.itinerary.id)
                }
              }
            )
        }
      }
      )
  }

  async loadBankDetaildata() {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/cms/payment-detail/`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          this.setState({ bank: data[0] })
        },

        (error) => {
          console.log(error, 'error------')
          localStorage.getItem("authUser") ? this.props.history.push('/itineraries') : this.props.history.push('/404')
        }
      )
  }

  async loadItineraryCreditTrans(itinerary_id) {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.state.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-credit-transactions/?itinerary__id=${itinerary_id}`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let options = []
          data.map(trans => {
            options.push({ label: `${trans.end_user} (${moment(trans.date).format("DD-MM-YYYY")})`, value: trans.id })
          })

          let TransactionGroup = [
            {
              label: "Transactions",
              options: options
            }
          ];
          this.setState({ creditTrans: data, TransactionGroup, selectedTransactions: options })
        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  // To validate User is Genuine 
  HandleValidateUserSubmit(e, values) {
    const { invoice } = this.state
    let phone = invoice.itinerary.phone
    if (phone[0] === "+") {
      phone = phone.split("-")[1]
    }
    if (phone === values.password) {
      this.setState({ authenticated: true })
    } else {
      toastr.error("Invalid Password")
    }

  }

  // For Open Print Preview Window  
  Print() {
    this.setState({ print: true })

    setTimeout(() => {
      window.print();
      this.setState({ print: false })
    }, 20);

  }
  // Get Sub Total from added Transactions amount 
  getSubTotal(transactions) {
    let sub_total = 0
    for (let i = 0; i < transactions.length; i++) {
      sub_total = sub_total + parseInt(transactions[i].amount)
    }
    return sub_total.toFixed(2)
  }

  // Save Updated Customer Detail 
  handleDetailSubmit(e, values) {
    if (this.state.obj) {
      const { invoice, selectedTransactions} = this.state
      this.setState({ loading: true })
      let transactions = []
      for (let i = 0; i < selectedTransactions.length; i++) {
        transactions.push(selectedTransactions[i].value)
      }
      let data = {}
      data['itinerary'] = invoice.itinerary.id
      data['name'] = values.name
      data['email'] = values.email
      data['address'] = values.address
      data['phone'] = values.phone
      data['date'] = values.date
      data['transactions'] = transactions
      console.log(transactions, selectedTransactions, "============>")


      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.state.obj.access}` },
        body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/invoices/invoices/${invoice.id}/`, requestOptions)
        .then(res => {
          if (res.status >= 400) {
            res.json()
              .then(
                (data) => {
                  console.log(data, "---data")
                  toastr.error("Something Went Wrong", "")
                  this.setState({ loading: false })
                }

              )
          }
          else {
            toastr.success(`Details Updated Successfully `, "")
            this.setState({ loading: false })
            this.tog_edit_detail()
            this.loadData()
          }
        }
        )
    }

  }

  handleSendInvoiceSubmit(e, values) {
    if (this.state.obj) {
      const { rawMessage } = this.state
      let message = encodeURIComponent(rawMessage)
      this.setState({ invoiceloading: true })
      let data = {
        "email": values.email,
        "data": message,
        "subject": values.subject,
      }

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.state.obj.access}` },
        body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/invoices/send-invoice/`, requestOptions)
        .then(res => {
          if (res.status >= 400) {
            this.setState({ invoiceloading: false, editorState: EditorState.createEmpty() })
          }
          else {
            toastr.success(`Invoice Has been Send on ${values.email}`)
            this.setState({ invoiceloading: false, editorState: EditorState.createEmpty() })
          }
        }
        )
    }

  }




  render() {
    const { invoice, bank, editorState } = this.state
    let breadcrumbItems = [
      { title: "Invoice Preview", link: "#" },
    ]
    if (!isEmpty(invoice)) (
      breadcrumbItems = [{ title: invoice.itinerary.name, link: `/itinerary-detail/${invoice.itinerary.id}` }, { title: "Invoices", link: `/invoices/${invoice.itinerary.id}` }, ...breadcrumbItems]
    )
    // const Columns = [
    //     {
    //         dataField: "id",
    //         text: "S.NO.",
    //         headerStyle: { width:'5%' },
    //         formatter: (cellContent, row, rowIndex) => (
    //           rowIndex+1    
    //       ),
    //       align: 'center'
    //     },

    //     {
    //         dataField: "end_user",
    //         text: "Receiced From",   
    //     },
    //     {
    //       dataField: "mode",
    //       text: "Mode",   
    //     },
    //     {
    //       dataField: "amount",
    //       text: "Amount",
    //       headerStyle: { width:'8%' },
    //       formatter: (cellContent, row) => (
    //         "₹ "+row.amount       
    //     ),
    //     align: 'right'
    //     },

    //     ]

    //   const expandRow = {
    //     renderer: row => (

    //         <p className="ml-4">{row.comment}</p>
    //     ),
    //     expanded:[18]
    //   };
    return (
      <React.Fragment>
        <div className="page-content">
          {this.state.authenticated || this.props.obj ?
            <Container fluid={true}>
              {this.props.obj ?
                <Breadcrumbs title="" breadcrumbItems={breadcrumbItems} /> : null}
              {!isEmpty(invoice) ? (
                <Row >

                  <Col xl="9">
                    <Card>
                      <CardBody>
                        <div className={this.state.print ? "p-5" : ""}>
                          <Row>
                            <Col sm="8">
                              <img className="rounded avatar-xl my-3" alt="avtarimage" style={{ height: 'auto', width: '200px' }} src={logo} />
                            </Col>
                            <Col sm="4">
                              <div className={this.state.isMobile ? "my-3" : "float-end  my-3"}>
                                <h5 ><b>Invoice:</b> <b style={{ color: "#3399cc" }}>{`I-${invoice.itinerary.id + 100}-${invoice.id}`}</b></h5>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="8">
                              <div>
                                <h6>Tour and Events Planners</h6>
                                <p>Planmans Group<br />
                                  Top Floor, Keonthal Commercial Complex<br />
                                  Khalini, Shimla, India - 171002<br />
                                  sales@planman.in <br />
                                  travel@hptourtravel.com</p>
                              </div>
                            </Col>

                            <Col sm="4">
                              <Row>
                                <Col >
                                  <div className={this.state.isMobile ? "" : "float-end"}><h6>Invoice Date:</h6></div>
                                </Col>
                                <Col>
                                  <div className={this.state.isMobile ? "" : "float-end"}><p><b>{moment(invoice.date).format('DD-MM-YYYY')}</b></p></div>
                                </Col>
                              </Row>
                              <Row>
                                <Col >
                                  <div className={this.state.isMobile ? "" : "float-end"}><h6>Transaction date:</h6></div>
                                </Col>
                                <Col>
                                  <div className={this.state.isMobile ? "" : "float-end"}><p><b>{moment(this.state.transactionDate).format('DD-MM-YYYY')}</b></p></div>
                                </Col>
                              </Row>

                            </Col>
                          </Row>
                          <hr />
                          <Row>
                            <Col sm="4">
                              <Row>
                                <Col sm="6">
                                  <h6>Invoice To:</h6>
                                </Col>
                              </Row>
                              <Row>
                                <p> <b style={{ color: "#3399cc" }}>{invoice.name}</b><br />
                                  {invoice.address}<br />
                                  {invoice.phone}<br />
                                  {invoice.email}</p>

                              </Row>
                            </Col>
                            <Col sm="8">
                              {/* <div className={this.state.isMobile?"":"float-end"}> */}

                              <Row>
                                {!this.state.isMobile ?
                                  <Col sm="4" ></Col> : null}
                                <Col sm="8" >
                                  <div className="table-responsive table-sm">

                                    <Table className="table-nowrap table-sm table-borderless mb-0">
                                      <tbody>
                                        <tr key={'payment_info'}>
                                          <th
                                            scope="row"
                                          // style={{ width: "40%" }}

                                          >
                                            <h6 className={this.state.isMobile ? "mb-3 ml-5" : "float-end mb-3 ml-5"} style={{ color: "#3399cc" }}>Payment Info:</h6>
                                          </th>
                                          {/* <td></td> */}
                                        </tr>
                                        <tr key={'acc_name'}>
                                          <th
                                            scope="row"
                                          // style={{ width: "40%" }}

                                          >
                                            <div className={this.state.isMobile ? "" : "float-end"}>Account Name:</div>
                                          </th>
                                          <td className={this.state.isMobile ? "" : "float-end"}>{bank?.account_name}</td>
                                        </tr>
                                        <tr key={'acc_number'}>
                                          <th
                                            scope="row"
                                          // style={{ width: "40%" }}

                                          >
                                            <div className={this.state.isMobile ? "" : "float-end"}>Account Number:</div>
                                          </th>
                                          <td className={this.state.isMobile ? "" : "float-end"}>{bank?.account_no}</td>
                                        </tr>
                                        <tr key={'bank_n'}>
                                          <th
                                            scope="row"
                                          // style={{ width: "40%"}}

                                          >
                                            <div className={this.state.isMobile ? "" : "float-end"}>Bank Name:</div>
                                          </th>
                                          <td className={this.state.isMobile ? "" : "float-end"}>{bank?.bank_name}</td>
                                        </tr>
                                        {/* <tr key={'bank_branch'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Branch"}
                                          </th>
                                          <td>{bank_detail?bank_detail.branch_name:""}</td>
                                      </tr> */}
                                        <tr key={'acc_ifsc'}>
                                          <th
                                            scope="row"
                                          // style={{ width: "40%" }}

                                          >
                                            <div className={this.state.isMobile ? "" : "float-end"}>IFSC code:</div>
                                          </th>
                                          <td className={this.state.isMobile ? "" : "float-end"}>{bank?.ifsc}</td>
                                        </tr>
                                        {/* <tr key={'upi_bank_n'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI Bank Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi_bank_name:""}</td>
                                      </tr>
                                      <tr key={'acc_upi'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi:""}</td>
                                      </tr> */}

                                      </tbody>
                                    </Table>
                                  </div>
                                </Col>

                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <div className="table-responsive mb-2">
                              {/* <Table > */}


                              <Table striped bordered hover size="sm">
                                <thead>
                                  <tr>
                                    <th>S.NO.</th>
                                    <th>Receiced From</th>
                                    <th>Mode</th>
                                    <th>Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {invoice.transactions.map((trans, index) => (
                                    <>
                                      <tr>
                                        <td>{index + 1}.</td>
                                        <td>{trans.end_user}</td>
                                        <td>{trans.mode}</td>
                                        <td style={{ textAlign: "right" }}>₹ {trans.amount}</td>
                                      </tr>
                                      <tr>
                                        <td colSpan={4}>{trans.comment}</td>
                                      </tr>
                                    </>

                                  ))}


                                </tbody>
                              </Table>
                            </div>
                          </Row>
                          <Row>
                            <Col sm="7">
                            </Col>
                            <Col sm="5">
                              <Row>
                                <Col >
                                  <div className={this.state.isMobile ? "" : "float-end"}><p><b>Sub Total:</b></p></div>
                                </Col>
                                <Col>
                                  <div className={this.state.isMobile ? "" : "float-end"}><p className="">₹ {this.getSubTotal(invoice.transactions)}</p></div>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div className={this.state.isMobile ? "" : "float-end"}><p><b>Pending Amount:</b></p></div>
                                </Col>
                                <Col>
                                  <div className={this.state.isMobile ? "" : "float-end"}><p className="">₹ {(parseInt(invoice.itinerary.pkg_const_margin) - parseInt(this.getSubTotal(invoice.transactions))).toFixed(2)}</p></div>
                                </Col>
                              </Row>
                              <Row>
                                <Col >
                                  <div className={this.state.isMobile ? "" : "float-end"}><p><b>GST Amount:</b></p></div>
                                </Col>
                                <Col>
                                  <div className={this.state.isMobile ? "" : "float-end"}><p className="">₹ {invoice.itinerary.tds_amount}</p></div>
                                </Col>
                              </Row>

                              <Row>
                                <Col >
                                  <div className={this.state.isMobile ? "" : "float-end"}><p><b>Discount Amount:</b></p></div>
                                </Col>
                                <Col>
                                  <div className={this.state.isMobile ? "" : "float-end"}><p className="">₹ {invoice.itinerary.discount_amount}</p></div>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div className={this.state.isMobile ? "" : "float-end"}><p><b>Grand Total:</b></p></div>
                                </Col>
                                <Col>
                                  <div className={this.state.isMobile ? "" : "float-end"}><p className="">₹ {invoice.itinerary.pkg_const_margin}</p></div>
                                </Col>
                              </Row>

                            </Col>
                          </Row>
                          <hr />
                          <Row>
                            <h6 className="mt-4">Thank You For Your Business and Association with us!</h6>
                          </Row>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  {!this.state.print ?
                    <Col xl="3">
                      <Card>
                        <CardBody>
                          {has_Permission(this.props.obj?.user, 7, 'read') ?
                            <Row>
                              <Button type="button" color="primary" onClick={this.tog_share} >Share Invoice</Button>
                            </Row> : null}

                          <Row className="mt-3">
                            <Button type="button" color="success" onClick={() => this.Print()} >Print/ Download</Button>
                          </Row>
                          {has_Permission(this.props.obj?.user, 7, 'edit') ?
                            <Row className="mt-3">
                              <Button type="button" color="secondary" onClick={this.tog_edit_detail} >Edit</Button>
                            </Row> : null}
                        </CardBody>
                      </Card>
                    </Col>
                    : null}
                </Row>
              ) : (
                <div className="d-flex align-items-center justify-content-center min-vh-100">

                  <Spinner type="grow" className="me-2" color="secondary" />
                  <Spinner type="grow" className="me-2" color="secondary" />
                  <Spinner type="grow" className="me-2" color="secondary" />
                  <Spinner type="grow" className="me-2" color="secondary" />

                </div>
              )}
              {/* Edit Custoner Detail Model */}
              <Col sm={6} md={4} xl={3} className="mt-4">

                <Modal
                  isOpen={this.state.model_edit_detail}
                  toggle={this.tog_edit_detail}
                  centered={true}
                >
                  <ModalHeader toggle={this.tog_edit_detail}>
                    Edit Detail
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handleDetailSubmit} >
                      <Row>
                        <Col xs={12}>
                          <Row className="mb-3">
                            <Label className="col-md-2 col-form-label" htmlFor="name">Name</Label>
                            <Col md={8}>
                              <AvField
                                name="name"
                                value={invoice.name}
                                type="text"
                                errorMessage="Enter Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="name"
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Label className="col-md-2 col-form-label" htmlFor="email">Email</Label>
                            <Col md={8}>
                              <AvField
                                name="email"
                                type="email"
                                value={invoice.email}
                                errorMessage="Enter Email"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="email"
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Label className="col-md-2 col-form-label" htmlFor="address">Address</Label>
                            <Col md={8}>
                              <AvField
                                name="address"
                                value={invoice.address}
                                type="text"
                                errorMessage="Enter Address"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="address"
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Label className="col-md-2 col-form-label" htmlFor="phone">Phone</Label>
                            <Col md={8}>
                              <AvField
                                name="phone"
                                value={invoice.phone}
                                type="text"
                                errorMessage="Enter Phone"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="phone"
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <hr />
                      <Col xs={12}>
                        <Row className="mb-3">
                          <Col md="8">
                            <div className="mb-3">
                              <Label className="form-label">Invoice For</Label>
                              <Select
                                value={this.state.selectedTransactions}
                                onChange={(e) => this.setState({ selectedTransactions: e })}
                                options={this.state.TransactionGroup}
                                isMulti={true}
                                classNamePrefix="select2-selection"
                                id={'invoice_transactions'}
                              />
                            </div>
                          </Col>
                         
                          <Col md="4">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="date">Invoice Date</Label>
                              <AvField
                                name="date"
                                placeholder="Invoice Date"
                                type="date"
                                errorMessage="Enter Invoice Date"
                                className="form-control"
                                value={moment(invoice.date).format('YYYY-MM-DD')}
                                validate={{ required: { value: true } }}
                                id="date"

                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>

                      <FormGroup className="mb-0">
                        {this.state.loading ? (
                          <Spinner className="me-2 mt-2" color="primary" />
                        ) : (
                          <div>
                            <Button type="submit" color="primary" className="me-1">Save</Button>
                          </div>
                        )}
                      </FormGroup>
                    </AvForm>

                  </ModalBody>
                </Modal>
              </Col>
              {/* Share Invoice Model  */}
              <Col sm={6} md={4} xl={3} className="mt-4">

                <Modal
                  isOpen={this.state.modal_share}
                  toggle={this.tog_share}
                  centered={true}
                >
                  <ModalHeader toggle={this.tog_share}>
                    Share Invoice
                  </ModalHeader>
                  <ModalBody>
                    <Nav tabs className="nav-tabs-custom nav-justified">
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTabJustify === "5"
                          })}
                          onClick={() => {
                            this.toggleCustomJustified("5");
                          }}
                        >
                          <span><span><i className="ri-mail-send-line"> Via Email</i></span></span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTabJustify === "6"
                          })}
                          onClick={() => {
                            this.toggleCustomJustified("6");
                          }}
                        >
                          <span><i className="fab fa-whatsapp"> Via WhatsApp</i></span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "url" }}
                          className={classnames({
                            active: this.state.activeTabJustify === "7"
                          })}
                          onClick={() => {
                            this.toggleCustomJustified("7");
                          }}
                        >
                          <span><i className=" far fa-copy"> URL</i></span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTabJustify}>

                      <TabPane tabId="5" className="p-3">
                        <AvForm className="needs-validation" onValidSubmit={this.handleSendInvoiceSubmit} >
                          <Row>
                            <Col md={12}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="user_email">Email</Label>
                                <AvField
                                  name="email"
                                  value={invoice.email}
                                  type="email"
                                  errorMessage="Enter Customer Name"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="user_email"
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="subject">Subject</Label>
                                <AvField
                                  name="subject"
                                  type="text"
                                  errorMessage="Enter Heading Name"
                                  className="form-control"
                                  value={'Invoice'}
                                  validate={{ required: { value: true } }}
                                  id="subject"
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Editor
                              toolbar={{
                                options: ['inline', 'fontSize', 'fontFamily', 'link'],
                                inline: {
                                  options: ['bold', 'italic', 'underline'],
                                },
                              }}
                              initialEditorState={editorState}
                              toolbarClassName="toolbarClassName"
                              wrapperClassName="wrapperClassName"
                              editorClassName="editorClassName"
                              onEditorStateChange={this.onEditorStateChange}
                            />
                          </Row>

                          <Row>

                            <Col md="6">
                              {this.state.invoiceloading ?
                                <Spinner className="mt-3" color="primary" />
                                :
                                <div className="mt-3">
                                  <Button type="submit" color="primary" className="">
                                    Share
                                  </Button>
                                </div>

                              }
                            </Col>
                          </Row>

                        </AvForm>
                      </TabPane>
                      <TabPane tabId="6" className="p-3">
                        <div className='d-flex align-items-center justify-content-center'>
                          <WhatsappShareButton
                            windowWidth="1024"
                            windowHeight={"800"}
                            from=""
                            url={`${BaseUrl}/invoice-preview/${invoice.id}`}
                            // title={invoice.itinerary.title.split("Ex")[0]}
                            separator="::"
                            className="Demo__some-network__share-button"
                          >
                            <WhatsappIcon size={50} round={true} />
                          </WhatsappShareButton>
                        </div>
                      </TabPane>
                      <TabPane tabId="7" className="p-3">
                        <Row>
                          <Col md={12}>
                            <AvForm>
                              <div className="mb-3">
                                <AvField
                                  name="url_link"
                                  type="text"
                                  errorMessage="Enter Subject Name"
                                  className="form-control"
                                  value={`${BaseUrl}/invoice-preview/${invoice.id}`}
                                  disabled
                                  id="url_link"
                                />
                              </div>
                            </AvForm>
                          </Col>
                        </Row>
                        <Row>
                          <Link to="#" onClick={() => { navigator.clipboard.writeText(`${BaseUrl}/invoice-preview/${invoice.id}`); toastr.success("URL Copied on Clip Board") }} className="text-dark"><i className=" far fa-copy font-size-30 float-end"> Copy URL</i></Link>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </ModalBody>
                </Modal>
              </Col>
            </Container> :
            <Container fluid={true}>
              <Col sm={6} md={4} xl={3} className="mt-4">

                <Modal
                  isOpen={true}
                  toggle={() => { this.props.history.goBack() }}
                >
                  <ModalHeader toggle={() => { this.props.history.goBack() }}>
                    Enter password
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.HandleValidateUserSubmit} >
                      <Row>
                        <Col xs={12}>
                          <Row className="mb-3">
                            <Label className="col-md-2 col-form-label" htmlFor="password">Password</Label>
                            <Col md={8}>
                              <AvField
                                name="password"
                                type="text"
                                errorMessage="Enter Password"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="password"
                              />
                            </Col>
                            <p>your mobile no is your password</p>
                          </Row>
                        </Col>
                      </Row>

                      <FormGroup className="mb-0">
                        {this.state.password_loading ? (
                          <Spinner className="me-2 mt-2" color="primary" />
                        ) : (
                          <div>
                            <Button type="submit" color="primary" className="me-1">Submit</Button>
                          </div>
                        )}
                      </FormGroup>
                    </AvForm>

                  </ModalBody>
                </Modal>
              </Col>
            </Container>
          }
        </div>
      </React.Fragment>
    );
  }
}

export default InvoicePage;



